module.exports = __webpack_public_path__ + "fonts/Inter-800-latin77.8e433c0.woff2";